import React from 'react';
import { ContainerCard, ItemHistory } from '../../molecules';
import { pathServer } from '../../../shared/constants/Constants';
import PSModal from '../../PSModal';
import { CreateManagementGalley } from '../index';

import './index.scss';

const Gallery = React.forwardRef(
  (
    {
      items,
      currentPhoto,
      onSelectGallery,
      showModalNewPhoto,
      onCreateNewPhoto,
      onCloseModal,
      saveGallery,
      onChangePhoto,
      deleteGallery,
      loadingSave,
    },
    ref
  ) => {
    return (
      <div className="container-gallery" ref={ref}>
        <div className="left-container">
          <h2>GALERÍA</h2>

          <div className="container-detail-table">
            <table className="w-100">
              <tbody>
                {items.map((item, index) => {
                  return (
                    <ItemHistory
                      key={index}
                      index={index}
                      className="m-1"
                      data={item}
                      onselect={(value) => onSelectGallery(value)}
                      onDelete={deleteGallery}
                    />
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
        <div className="right-container">
          <div>
            <div className="add-new">
              <img src={`${pathServer.PATH_ICONS}icon_add.svg`} onClick={onCreateNewPhoto} />
              <p>NUEVA FOTOGRAFIA</p>
            </div>
            {currentPhoto && (
              <div className="">
                <ContainerCard className="m-1">
                  <img className="img-preview" src={currentPhoto.linkPhoto} />
                </ContainerCard>
                <ContainerCard className="m-1">
                  <span>Descripcion</span>
                  <label>{currentPhoto.description}</label>
                </ContainerCard>
              </div>
            )}
          </div>
        </div>

        {showModalNewPhoto && (
          <PSModal
            open={showModalNewPhoto}
            onClose={onCloseModal}
            classNames={{
              overlay: 'customOverlay',
              modal: 'customModalPreview modalGallery',
            }}
          >
            <CreateManagementGalley
              onClose={onCloseModal}
              onSave={saveGallery}
              onChange={onChangePhoto}
              loadingSave={loadingSave}
            />
          </PSModal>
        )}
      </div>
    );
  }
);

Gallery.displayName = 'Gallery';

Gallery.defaultProps = {};

Gallery.propTypes = {};

export default Gallery;
